module.exports = __webpack_public_path__ + "media/seeYouSoon.8deb657f.mp3";